import React, { useState, useEffect } from 'react';
import { AuthContext } from './AuthContext';
import apiClient from '../api/apiClient';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie'; // Add this

export default function AuthProvider({ children }) {
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // Call backend to verify login using cookie
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await apiClient.get('/admin/check-auth', {
          withCredentials: true, // Include credentials (cookies) in the request
        });
        if (response.status === 200) {
          setAuthenticated(true);
        } else {
          setAuthenticated(false);
        }
      } catch (error) {
        console.error('Error checking authentication:', error);
        setAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
}, [location.pathname]);

      

  return (
    <AuthContext.Provider value={{ isAuthenticated, setAuthenticated, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
